import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeoAreaSipKpi } from 'src/app/assabil-sales/models/dtos/geo-area-sip-kpi';

@Component({
  selector: 'geo-area-sip-kpi',
  templateUrl: './geo-area-sip-kpi.component.html',
  styleUrls: ['./geo-area-sip-kpi.component.scss']
})
export class GeoAreaSipKpiComponent implements OnInit {


  @Input() geoAreaSipKpi : GeoAreaSipKpi;

  @Output() onClick        = new EventEmitter<any>();
  @Input() previousPeriod : string;

  
  constructor() { }

  ngOnInit() {
  }


  clickTitle() {

  } 
  
  click(event : any){
    this.onClick.emit(event);
  }

  clicked(){
    this.geoAreaSipKpi.expanded = !this.geoAreaSipKpi.expanded;
  }
}